import { CmsABTest } from '@/api/cms';
import { abTestingFunction } from '@/helpers/abTesting';

export enum ExpProceedToDepAfterShortReg {
  A = 'exp_proceed_to_dep_after_short_reg2_ver_a',
  B = 'exp_proceed_to_dep_after_short_reg2_ver_b',
}

export const showImmidiatellyAdditionalDataStepRequiredABTest = (
  cmsABTests: CmsABTest[]
) => {
  return (
    abTestingFunction(
      'exp_proceed_to_dep_after_short_reg2',
      {
        defaultVersion: ExpProceedToDepAfterShortReg.A,
        versions: [
          { name: ExpProceedToDepAfterShortReg.A, probability: 50 },
          { name: ExpProceedToDepAfterShortReg.B, probability: 50 },
        ],
      },
      undefined,
      undefined,
      cmsABTests
    ) === ExpProceedToDepAfterShortReg.B
  );
};
